import React, { useState, useContext, useEffect } from 'react';

// context
import { ListContext } from '@/context/ListContext';
import { ContentListContext } from '../../../../context/ListPageContext';


const UseContentList = () => {
    const [widgetPanelOpen, setWidgetPanelOpen] = useState<boolean>(false)
    const {menuItems, sortType, setSortType, updateListContentItems, paginationSettings, viewOption, setViewOption, notificationDetails } = useContext(ContentListContext);
    const {hasEditorRights, listId, listTitle, isCombinedFeedEnabled} = useContext(ListContext);
    const [savingContent, setSavingContent] = useState<boolean>(false);
    const [listTitleError, setListTitleError] = useState<boolean>(false);

    useEffect(() => {
        (window as any).functions = {...window.functions, closeWidgetPanel: () => setWidgetPanelOpen(false)}
    },[])

    useEffect(() => {
        setListTitleError(false);
    },[listTitle])

    useEffect(() => {
        if (+listId > 0 && savingContent) {
            setWidgetPanelOpen(true);
            setSavingContent(false)
        }
    },
    [listId]);

    useEffect(() => {
        if (document.querySelector('.tab-nav')) {(document.querySelector('.tab-nav') as HTMLDivElement).style.marginBottom = '24px';}

        if (!hasEditorRights) {
            if (document.querySelector('.savePanel')) {(document.querySelector('.savePanel') as HTMLDivElement).style.display = 'none';}
            if (document.querySelector('#react-schedulepush-container')) { (document.querySelector('#react-schedulepush-container') as HTMLDivElement).style.display = 'none';}
        } else {
            if (document.querySelector('.savePanel')) {(document.querySelector('.savePanel') as HTMLDivElement).style.display = 'block';}
            if (document.querySelector('#react-schedulepush-container')) { (document.querySelector('#react-schedulepush-container') as HTMLDivElement).style.display = 'block';}
        }
    },[hasEditorRights])

    async function handleWidgetPanelOpen(value: boolean) {
        if(!value){
            setWidgetPanelOpen(false)
        }

        if (!listTitle) {
            setListTitleError(true)
            return 
        } else if (+listId === 0) {
            if(!savingContent) {
                await (window as any)?.SaveContent(false);
                setSavingContent(true);
            }   
        } else {
            setWidgetPanelOpen(value);
        }        
    }

    return {widgetPanelOpen, setWidgetPanelOpen: handleWidgetPanelOpen, menuItems, sortType, setSortType, updateListContentItems, paginationSettings, viewOption, setViewOption, hasEditorRights, savingContent, listTitleError, notificationDetails, isCombinedFeedEnabled}
}

export default UseContentList